import { Link } from 'react-router-dom';

const Item = ({ requests }) => {
    const badges = {
        new: 'badge-danger',
        inwork: 'badge-warning',
        complete: 'badge-success'
    };

    const products = {
        'course-html': 'Курс по верстке',
        'course-js': 'Курс по JavaScript',
        'course-vue': 'Курс по Vue JS',
        'course-php': 'Курс по PHP',
        'course-wordpress': 'Курс по WordPress',
    }

    const statuses = {
        'new': 'Новая',
        'inwork': 'В работе',
        'complete': 'Завершена',
    }

    
    return requests.map((item) => {
        const formattedDate = new Date(item.date).toLocaleDateString();
        return (
                
                <tr key={item.id}>
                    <th scope="row">{item.id}</th>
                    <td>{formattedDate}</td>
                    <td>{products[item.product]}</td>
                    <td>{item.fullName}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>
                        <div className={`badge badge-pill ${badges[item.status]}`}>
                        {statuses[item.status]}
                        </div>
                    </td>

                    <td>
                        <Link to={`/edit/${item.id}`}>Редактировать</Link>
                    </td>   
                </tr>
        );
    });
}

export default Item;